// extracted by mini-css-extract-plugin
export default {"address":"privacy_address__dh-GK"};